<div class="form-fields">
  {{#each fields}}
    {{> (fbPartial . "type") prefix="patient_journey_data_element" name="value" }}
  {{/each}}
</div>
